module.exports = __webpack_public_path__ + "static/4-9e979e4eec0cde679d50aa4a42f219f6.jpg";